import { ExceptionStatusTag } from '@ProdWb/ExceptionFailureList/TableColumns'
import { AssigneeMappingForFailures } from '@ProdWb/ExceptionFailureList/constants'

import Box from '~/core/Box'
import { ExceptionDisplayType } from '../types'
import ExceptionTypeTag from '../../ExceptionTypeTag'
import { OPS_PRODUCTION_PATH } from '~/redux-modules/preferences'
import Link from '~/core/Link'
import Text from '~/core/Text'

import { ExceptionsListHeader } from './ExceptionListHeader'
import { ExceptionsListDetails } from './ExceptionListDetails'

export const ExceptionDisplay = (props: ExceptionDisplayType) => {
    const { item } = props

    return (
        <>
            <ExceptionsListHeader
                id={item.id}
                name={item.name}
                updatedAt={item.updatedAt}
            />
            <Box direction="col">
                <ExceptionsListDetails
                    title="Exception/failure status"
                    content={
                        <ExceptionStatusTag
                            reportState={item.exceptionFailureState}
                        />
                    }
                />
                <ExceptionsListDetails
                    title="Exception type"
                    content={
                        <ExceptionTypeTag
                            type={item.type}
                            assignedTo={item.assignedEntity}
                            customerAffected={item.isCustomerImpacted}
                            exceptionStatus={item.exceptionFailureState}
                            milestone={item.milestoneType}
                        />
                    }
                />
                {item.correctiveActionRequest && (
                    <ExceptionsListDetails
                        title="CAR"
                        content={
                            <Link
                                name="view-exception-details"
                                data-test-target="view-exception-details"
                                from={`${OPS_PRODUCTION_PATH}/jobs`}
                                href={`${OPS_PRODUCTION_PATH}/car/${item.correctiveActionRequest.id}`}
                                target="_blank"
                            >
                                <Text>{item.correctiveActionRequest.name}</Text>
                            </Link>
                        }
                    />
                )}
                <ExceptionsListDetails title="Action" content={item.action} />
                <ExceptionsListDetails
                    title="Action assignee"
                    content={
                        AssigneeMappingForFailures[item.assignee as string]
                    }
                />
                <ExceptionsListDetails
                    title="Note"
                    content={item.latestNote?.body || null}
                    isLongText={true}
                />
            </Box>
        </>
    )
}
